import React, { useEffect, useRef, useState, useContext } from "react";
import clsx from "clsx";
import { cookie } from "../../util/JWTCookie";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import { useHistory, useLocation } from "react-router-dom";
import ErrorOutlinedIcon from "@material-ui/icons/ErrorOutlined";
import { ReactComponent as LogOutIcon } from "../../assets/svg/logout-icon.svg";
import AppsIcon from "@material-ui/icons/Apps";
import Tooltip from "@material-ui/core/Tooltip";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import CloseIcon from "@material-ui/icons/Close";
import { Col, Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import PortalModal from "../../Portals";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import PersonIcon from "@mui/icons-material/Person";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ReactComponent as ChatIcon } from "../../assets/svg/chat-icon.svg";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { ReactComponent as MenuIconCollapse } from "../../assets/svg/menu-icon-collapse.svg";
import { ReactComponent as MenuIconNotification } from "../../assets/svg/notification.svg";
import { ReactComponent as MenuIconExpand } from "../../assets/svg/menu-icon-expand.svg";
import { Visibility } from "@material-ui/icons";
import {
  GeneralStyle,
  IconCollapseStyle,
  DisplayName,
  ImageLogout,
  ContentUserInfo,
  ImgLogoTPHomeMenu,
  ContentModalGlobal,
  CloseModalGlobal,
  TextModalGlobal,
  ButtonGlobal,
  ButtonMoodMeter,
  ImageApps,
  ContentTooltip,
  ButtonApp,
  ImageContainer,
  NameClient,
  ContentChangeTenant,
  ButtonsChangeTenant,
  ButtonCreate,
  ButtonCancel,
  HR,
  RightSeparator,
  MainContent,
  LoginButton,
  ContentRight,
  ContentQr,
  HeaderContentQr,
  InfoQrCode,
  QrImg,
  ContentPersonIcon,
  ContentProfileIcon,
  SOSCountRequests,
  useStyles,
  CenterContainer,
  TPIDContainer,
  Overlay,
  ContentRowData,
  ICEButton,
  ButtonNotification,
  ContainterNotificationHome,
  Picture,
  MiniPicture,
} from "./HomeMain.styled";
import { clientWellness } from "../../App";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import logohomemenu from "../../assets/svg/tns-logo-2.0.svg";
import { ContextBulkUpload } from "../../Store/StoreBulkUpload";
import { ReactComponent as IconMoodMeterMenu } from "../../themes/Icons/FeelingFaces/IconMoodMeterMenu.svg";
import MoodMeterContainer from "../MoodMeterContainer/MoodMeterContainer";
import { NotificationManager } from "react-notifications";
import {
  MOOD_METER_GET_CONFIGURATION,
  USERS_FEELING_BY_USERID,
  GET_MENU_BY_ROLE,
  GET_EVENTS_NOT_RATED,
  GET_ICE_BUTTON_STATUS,
  ICE_REQUEST_BY_WELLNESS_CITY,
  INSTANT_MESSAGES,
  GET_UPDATE_TPID_CONFIRMATION,
  CURRENT_USER_SUPERVISOR,
  USERS_FEELING_BY_USER_AND_DATE,
  ALL_ASSIGNED_SURVEYS_FROM_TO,
  MOOD_METER_REQUESTS,
  UPCOMING_EVENTS_LIST,
  CURRENT_USER_INFO,
  ALL_WELLNESS_MAIL_BY_CITY,
  MY_CLIENT_SWITCH_LIST,
  MY_PROFILE_PICTURE,
  ICE_IS_THERE_CITY_CONTACTS,
} from "../../GraphQL/Queries";
import {
  MOVE_TO_CLIENT,
  CREATE_EVENT_FEEDBACK,
  GET_QRUSER,
  SEND_ICE_ALERT,
  SEND_ICE_ALERT_RESPONSE,
  CLOSE_ICE_ALERT_REQUEST,
  UPDATE_TP_ID,
  ACK_MOOD_METER_REQUESTS,
  CLOSE_MOOD_METER_REQUESTS,
  SEND_MOOD_INSTANT_MESSAGE,
  ENCRIPT_PARAMETERS,
  ACK_ICE_REQUESTS,
} from "../../GraphQL/Mutations";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import "react-pro-sidebar/dist/css/styles.css";
import knowledgeWafle from "../../assets/knowledgeWafle.png";
import {
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  Checkbox,
  TableRow,
} from "@material-ui/core";
import { getFile } from "../../services/FileManager";
import EventsFeedbackContainer from "../EventsFeedbackContainer/EventsFeedbackContainer";
import NotificationResearchContainer from "../NotificationResearchContainer/NotificationResearchContainer";
import ModalRequestsSOS from "../../components/ModalRequestsSOS/ModalRequestsSOS";
import ModalInstantMessages from "../../components/ModalInstantMessages/ModalInstantMessages";
import ModalICEAdminMessage from "../../components/ModalICEAdminMessage/ModalICEAdminMessage";
import { ai } from "../../helpers/appInsights";
import ModalUpdateId from "../../components/ModalUpdateId/ModalUpdateId";
import moment from "moment";
import { ROLES } from "../../util/RolesConstants";
import AllEventPrompts from "../../components/AllEventPrompts/AllEventPrompt";
import {
  format_end_date_ISO,
  format_start_date_ISO,
} from "../../util/UtilityFunctions";
import IceButtonComponent from "../IceModal/IceModal";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import ModalProfile from "../../components/ModalProfile/ModalProfile";
import { getProfilePhotoByName } from "../../services/UserProfilePhotosManager";
import PropTypes from "prop-types";
import SideMenu from "../../components/SideMenu/SideMenu";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    pointerEvents: "auto",
    backgroundColor: themeConfig.neutral.white,
    margin: "9px 0",
    color: themeConfig.neutral.gray[2500],
    border: "1px solid #dadde9",
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

const HtmlTooltipProfile = withStyles((theme) => ({
  tooltip: {
    pointerEvents: "auto",
    background: `linear-gradient(to bottom, ${themeConfig.primary.purple} 30%, ${themeConfig.neutral.white} 35%)`,
    overflow: "hidden",
    width: "30em",
    color: themeConfig.neutral.gray[2500],
    border: "1px solid #dadde9",
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: `0 0 0 0.2rem ${themeConfig.primary.blue}40`,
    },
  }),
};

const HomeMain = ({
  isAuthenticated,
  userInfo,
  handleLogin,
  handleLogOut,
  children,
  menuList,
  setMenuList,
}) => {
  const classes = useStyles();
  let rChangeTenant = useRef();
  const [open, setOpen] = useState(false);
  const [urlKnowledged, setUrlKnowledged] = useState("#");
  const [showLoader, setShowLoader] = useState(false);
  const [nameClient, setNameClient] = useState("");
  const [logoClient, setLogoClient] = useState("");
  const [, setUrlPolicyInsights] = useState("#");
  const [openAppsHandler, setOpenAppsHandler] = useState(false);
  const [isCollapse, setIsCollapse] = useState(true);
  const [user, setUser] = useState(getStateLoginComplete());
  const [tpid, setTpId] = useState("");
  const history = useHistory();
  const location = useLocation();
  const [stateBulkUploadReducer, dispatch] = useContext(ContextBulkUpload);
  const [choiceSelected, setChoiceSelected] = useState("");
  const [showTenantChange, setShowTenantChange] = useState(false);
  const [tenantsList, setTenantsList] = useState([]);
  const [showICEAdminMessage, setShowICEAdminMessage] = useState(false);
  const [showMoodAdminMessage, setShowMoodAdminMessage] = useState(false);
  const [openMoodMeterModal, setOpenMoodMeterModal] = useState(false);
  const [openConfigAdmin, setOpenConfigAdmin] = useState(false);
  const [messageConfigAdmin, setMessageConfigAdmin] = useState("");
  const [, setDayActualPlusThreeDays] = useState(false);
  const [daySaved, setDaySaved] = useState();
  const [timeConfig, setTimeConfig] = useState({});
  const [dayOfToday] = useState(new Date().getDate());
  const [openProfile, setOpenProfile] = useState(null);
  const [showManualTwoFactor, setShowManualTwoFactor] = useState(false);
  const [codeQR, setcodeQR] = useState("");
  const [showICE, setShowICE] = useState(false);
  const [showRequestsICE, setShowRequestsICE] = useState(false);
  const [showRequestsMood, setShowRequestsMood] = useState(false);
  const [showInstantMessagesICE, setShowInstantMessagesICE] = useState(false);
  const [showInstantMessagesMood, setShowInstantMessagesMood] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [backTitleInstant, setBackTitleInstant] = useState("");
  const [locationTitleInstant, setLocationTitleInstant] = useState("");
  const [listOfRequests, setListOfRequests] = useState([]);
  const [moodRequests, setMoodRequests] = useState([]);
  const [listOfInstantMessage, setListOfInstantMessage] = useState([]);
  const [instantMessageSelected, setInstantMessageSelected] = useState([]);
  const [iceRequestId, setIceRequestId] = useState(null);
  const [eventsNotRated, setEventsNotRated] = useState([]);
  const [ICEStatus, setICEStatus] = useState("");
  const [, setMoodStatus] = useState("Closed");
  const [showIDModal, setShowIDModal] = useState(false);
  const [superVisorId, setSuperVisorId] = useState(null);
  const refMoodMeterButton = useRef();
  const [overlay, setOverlay] = useState(false);
  const [dataICENotification, setDataICENotification] = useState();
  const [dataMoodNotification, setDataMoodNotification] = useState();
  const [openICENotification, setOpenICENotification] = useState(false);
  const [openMoodNotification, setOpenMoodNotification] = useState(false);
  const [ICEWellnessMessages, setICEWellnessMessages] = useState([]);
  const [notificationEvent, setNotificationEvent] = useState("");
  const [MoodWellnessMessages, setMoodWellnessMessages] = useState([]);
  const [connectionWR, setConnectionWR] = useState(null);
  const [connectionSR, setConnectionSR] = useState(null);
  const [surveysAssigned, setSurveysAssigned] = useState([]);
  const [eventsAssigned, setEventsAssigned] = useState([]);
  const [moodReceived, setMoodReceived] = useState(false);
  const [showICEInfo, setShowICEInfo] = useState(false);
  const [openICERequests, setOpenICERequests] = useState(false);
  const [openNotifiModal, setOpenNotifiModal] = useState(false);
  const [activeIceButton, setActiveIceButton] = useState(false);
  const [enableIceButton, setEnableIceButton] = useState("");
  const [selectedUsersForMoodMeter, setSelectedUsersForMoodMeter] = useState(
    []
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModalProfile, setOpenModalProfile] = useState(false);
  const [createEventFeedback] = useMutation(CREATE_EVENT_FEEDBACK, {
    client: clientWellness,
  });
  const [MoveToClient] = useMutation(MOVE_TO_CLIENT);
  const [GetQrUser] = useMutation(GET_QRUSER);
  const [sendIceAlert] = useMutation(SEND_ICE_ALERT, {
    client: clientWellness,
  });
  const [sendIceAlertResponse] = useMutation(SEND_ICE_ALERT_RESPONSE, {
    client: clientWellness,
  });
  const [sendMoodInstantMessage] = useMutation(SEND_MOOD_INSTANT_MESSAGE);
  const [closeIceAlertRequest] = useMutation(CLOSE_ICE_ALERT_REQUEST, {
    client: clientWellness,
  });
  const [closeMoodAlertRequest] = useMutation(CLOSE_MOOD_METER_REQUESTS);
  const [updateTpId] = useMutation(UPDATE_TP_ID);
  const [encriptParameters] = useMutation(ENCRIPT_PARAMETERS);
  const [ackMoodMeterRequest] = useMutation(ACK_MOOD_METER_REQUESTS);
  const [ackICERequest] = useMutation(ACK_ICE_REQUESTS, {
    client: clientWellness,
  });

  const [shortName] = useState(
    `${user.displayName.split(" ")[0].charAt(0) +
    "" +
    user.displayName.split(" ")[1].charAt(0)
    }`
  );
  const [colorSelected, setColorSelected] = useState("");
  const [photoProfile, setPhotoProfile] = useState("");
  const [myProfilePicture, setMyProfilePicture] = useState();
  const [selectedTenantOption, setSelectedTenantOption] = useState(null);

  const [runQueryMyProfilePicture] = useLazyQuery(MY_PROFILE_PICTURE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setMyProfilePicture(data.myProfilePicture);
    },
  });
  const [runQueryInstantMessages] = useLazyQuery(INSTANT_MESSAGES, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (data) => {
      const instantMessages = data?.instantMessages.map((im) => ({ ...im }));
      if (instantMessages) {
        setListOfInstantMessage(instantMessages);
      }
    },
  });
  const [runQueryIceRequestByWellnessCity, { loading: loadingICERequests }] =
    useLazyQuery(ICE_REQUEST_BY_WELLNESS_CITY, {
      fetchPolicy: "network-only",
      client: clientWellness,
      onCompleted: (data) => {
        const editable = data.iceRequestByWellnessCity.map((ice) => ({
          ...ice,
        }));
        if (editable) {
          setListOfRequests(editable);
        }
      },
    });
  const [runQueryMoodRequests, { loading: loadingMoodRequests }] = useLazyQuery(
    MOOD_METER_REQUESTS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        const moodMeterRequests = data.moodMeterRequests.map((mood) => ({
          ...mood,
        }));
        if (moodMeterRequests) {
          setMoodRequests(moodMeterRequests);
        }
      },
    }
  );
  const [runQueryGetEventsNotRated, { loading: loadingEvents }] = useLazyQuery(
    GET_EVENTS_NOT_RATED,
    {
      fetchPolicy: "network-only",
      client: clientWellness,
      onCompleted: (response) => {
        if (response?.eventsNonRatedByUser) {
          setEventsNotRated(response.eventsNonRatedByUser);
        }
      },
    }
  );

  const [runQueryUpcomingEventsList] = useLazyQuery(UPCOMING_EVENTS_LIST, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (data) => {
      if (data?.myUpcomingEvents) {
        const today = new Date().getDate();
        const date = new Date();
        date.setDate(date.getDate() + 1);
        const tomorrowDay = date.getDate();
        date.setDate(date.getDate() + 2);
        const threeDay = date.getDate();
        date.setDate(date.getDate() + 4);
        const sevenDay = date.getDate();
        let dateObj = {};
        dateObj[today] = "red-card";
        dateObj[tomorrowDay] = "yellow-card";
        dateObj[threeDay] = "blue-card-3";
        dateObj[sevenDay] = "blue-card";
        setEventsAssigned(data.myUpcomingEvents);
        setOpenNotifiModal(true);
        setOverlay(true);
      }
    },
  });

  const [runQueryAllAssignedSurveysAgent] = useLazyQuery(
    ALL_ASSIGNED_SURVEYS_FROM_TO,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (data?.filterMyAssignedSurveys) {
          const today = new Date().getDate();
          const date = new Date();
          date.setDate(date.getDate() + 1);
          const tomorrowDay = date.getDate();
          date.setDate(date.getDate() + 2);
          const threeDay = date.getDate();
          date.setDate(date.getDate() + 4);
          const sevenDay = date.getDate();
          let dateObj = {};
          dateObj[today] = "red-card";
          dateObj[tomorrowDay] = "yellow-card";
          dateObj[threeDay] = "blue-card-3";
          dateObj[sevenDay] = "blue-card";
          let surveys = data.filterMyAssignedSurveys.map((e) => {
            let endDate = e?.goToSurveyInfo?.schedule?.endDate;
            if (endDate) {
              let enddateObj = new Date(endDate);
              let endDay = enddateObj.getUTCDate();
              if (dateObj[endDay]) {
                return {
                  ...e,
                  cardClass: dateObj[endDay],
                };
              }
              return e;
            }
          });
          surveys = surveys.filter(
            (e) => e !== undefined && e["cardClass"] !== undefined
          );
          surveys = surveys.sort((a, b) => {
            let aDate = a?.goToSurveyInfo?.schedule?.endDate;
            let bDate = b?.goToSurveyInfo?.schedule?.endDate;
            return new Date(aDate) - new Date(bDate);
          });
          setSurveysAssigned(surveys);
        } else {
          setSurveysAssigned([]);
        }
      },
    }
  );
  const [runQueryGetICEStatus] = useLazyQuery(GET_ICE_BUTTON_STATUS, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (data) => {
      if (data?.iceRequestButtonStatusByUser) {
        setICEStatus(data.iceRequestButtonStatusByUser);
      }
    },
  });
  const [runQueryGetUserInfo] = useLazyQuery(CURRENT_USER_SUPERVISOR, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const superVisor = data?.currentUser[0]?.supervisorId;
      if (superVisor && superVisor !== null) {
        setSuperVisorId(superVisor);
      }
    },
  });
  const [runQueryGetMenu, { loading: loadingGetMenu }] = useLazyQuery(
    GET_MENU_BY_ROLE,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let MenuData = [];
        let knowledgeManagementURL = "";
        let policyInsightURL = "";
        if (data.menuByRole) {
          data.menuByRole
            .filter((f) => f.idParentMenu == null || f.idParentMenu === "")
            .map((menu, i) => {
              let submenu = data.menuByRole
                .filter((f) => f.idParentMenu === menu.menuId)
                .map((m) => {
                  return {
                    id: m.menuId,
                    text: m.title,
                    route: m.route,
                    topBanner: m.topBanner,
                    idParentMenu: m.idParentMenu,
                  };
                });
              let opcMenu = {
                id: menu.menuId,
                text: menu.title,
                icon: menu.icon,
                color: menu.color,
                route: menu.route,
                submenu: {
                  idParentMenu: submenu[0]?.idParentMenu,
                  data: submenu,
                },
                groupMenu: menu.groupMenu,
                menuPosition: menu.menuPosition,
                topBanner: menu.topBanner,
              };
              if (menu.title.indexOf("Knowledge Managment") !== -1) {
                knowledgeManagementURL = menu.link;
              }
              if (menu.title.indexOf("Policy Insight") !== -1) {
                policyInsightURL = menu.link;
              }
              MenuData.push(opcMenu);
            });
        } else {
          NotificationManager.warning(data.menuByRole.message, "", 5000);
        }

        MenuData = MenuData.filter((menu) => menu.groupMenu !== "Waffle");
        MenuData = MenuData.sort((a, b) => {
          return a.menuPosition - b.menuPosition;
        });
        setMenuList(MenuData);
        setUrlKnowledged(knowledgeManagementURL);
        setUrlPolicyInsights(policyInsightURL);
      },
    }
  );
  const [
    runQueryGetTimeConfig,
    { loading: loadingGetTimeConfig, error: errorGetTimeConfig },
  ] = useLazyQuery(MOOD_METER_GET_CONFIGURATION, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      handlerUsersFeelingByUserId({
        variables: {
          userId: user.userId,
          dateEntry: new Date().toISOString(),
        },
      });
      if (!data.moodMeterGetConfiguration.withError) {
        setTimeConfig(data.moodMeterGetConfiguration.outputData);
      } else {
        NotificationManager.error(
          data.moodMeterGetConfiguration.message,
          "",
          5000
        );
      }
    },
  });
  const [
    handlerUsersFeelingByUserId,
    { loading: loadingFeeling, error: errorFeeling },
  ] = useLazyQuery(USERS_FEELING_BY_USER_AND_DATE, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (!data.usersFeelingByUserAndDate.withError) {
        if (data?.usersFeelingByUserAndDate?.outputData?.length > 0) {
          let allFeelingsToday = data.usersFeelingByUserAndDate.outputData;
          validateOpenMoodMeterModal(allFeelingsToday, allFeelingsToday.length);
          setMoodReceived(true);
        } else {
          let allFeelingsToday = !data?.usersFeelingByUserAndDate?.outputData
            ? []
            : data.usersFeelingByUserAndDate.outputData;
          validateOpenMoodMeterModal(allFeelingsToday, allFeelingsToday.length);
        }
      } else {
        NotificationManager.error(
          data.usersFeelingByUserAndDate.message,
          "",
          5000
        );
      }
    },
  });
  const [runQueryUsersFeelingByUserId] = useLazyQuery(USERS_FEELING_BY_USERID, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.usersFeelingByUserId.withError) {
        if (data?.usersFeelingByUserId?.outputData?.length > 0) {
          let allFeelingsBefore = [];
          let allFeelingsToday = [];
          allFeelingsBefore = data.usersFeelingByUserId.outputData.filter(
            (element) => {
              let createDate = new Date(element?.createDate).getDate();
              if (createDate < dayOfToday) {
                return element;
              }
            }
          );
          allFeelingsToday = data.usersFeelingByUserId.outputData.filter(
            (element) => {
              let createDate = new Date(element?.createDate).getDate();
              if (createDate === dayOfToday) {
                return element;
              }
            }
          );
          let lastDay = new Date(
            allFeelingsBefore[allFeelingsBefore.length - 1]?.createDate
          );
          setDayActualPlusThreeDays(
            !allFeelingsToday.length &&
            new Date(lastDay.setDate(lastDay.getDate() + 3)) < new Date()
          );
        }
      } else {
        NotificationManager.error(
          data.usersFeelingByUserAndDate.message,
          "",
          5000
        );
      }
    },
  });

  const [runQueryGetClients] = useLazyQuery(MY_CLIENT_SWITCH_LIST, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let dto = data?.myClientSwitchList?.map((m, index) => {
        return {
          ...m,
          value: m.clientId,
          label: m.clientName,
          clientId: m.clientId,
          logo: m.logoName,
        };
      });
      let pos = dto.findIndex((element) => element.clientId === user.clientId);
      setNameClient(dto[pos].label);
      getLogoForClient(dto[pos].logo);
      setTenantsList(dto);
    },
  });

  const [runQueryGetTPIDConfirmation] = useLazyQuery(
    GET_UPDATE_TPID_CONFIRMATION,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data?.currentUser.tpIdValidated) {
          setShowIDModal(true);
        }
      },
    }
  );

  const [runQueryICEIsThereCityContacts] = useLazyQuery(
    ICE_IS_THERE_CITY_CONTACTS,
    {
      fetchPolicy: "network-only",
      client: clientWellness,
      onCompleted: (data) => {
        setActiveIceButton(data?.iceIsThereCityContacts);
      },
    }
  );

  const { data: userdata } = useQuery(CURRENT_USER_INFO, {
    variables: { userId: user.userId },
    context: { clientName: "LinkUsers" },
  });

  const [runQueryAllWellnessMailByCity] = useLazyQuery(
    ALL_WELLNESS_MAIL_BY_CITY,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let selectUsers = data.allWellnessMailByCity.outputData.map(
          (element) => ({ ...element })
        );
        setSelectedUsersForMoodMeter(selectUsers);
      },
    }
  );

  const MoodRequestColumns = [
    {
      title: "Name",
      field: "name",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.name}>
            <ContentRowData>{rowData.name}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "TP ID",
      field: "tpid",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.tpId}>
            <ContentRowData>{rowData.tpId}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Location",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.location}>
            <ContentRowData>{rowData.location}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Date and time",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={moment(rowData.dateTime).format("DD-MM-YYYY hh:mm")}>
            <ContentRowData>
              {moment(rowData.dateTime).format("DD-MM-YYYY hh:mm")}
            </ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Acknowledge",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <TableRow onClick={(event) => event.stopPropagation()}>
            <Tooltip title={rowData.ack}>
              <FormGroup style={{ color: themeConfig.neutral.black, paddingBottom: "10px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ padding: "0 10px 20px" }}
                      checked={rowData.ack}
                      disabled={rowData.ack}
                      onChange={() => {
                        handleAckMoodRequest(rowData);
                      }}
                      name="contact-check"
                    />
                  }
                />
              </FormGroup>
            </Tooltip>
          </TableRow>
        );
      },
    },
  ];

  const ICERequestColumns = [
    {
      title: "Name",
      field: "name",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.name}>
            <ContentRowData>{rowData.name}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "TP ID",
      field: "tpid",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.tpId}>
            <ContentRowData>{rowData.tpId}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Location",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={rowData.location}>
            <ContentRowData>{rowData.location}</ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Date and time",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <Tooltip title={moment(rowData.dateTime).format("DD-MM-YYYY hh:mm")}>
            <ContentRowData>
              {moment(rowData.dateTime).format("DD-MM-YYYY hh:mm")}
            </ContentRowData>
          </Tooltip>
        );
      },
    },
    {
      title: "Acknowledge",
      field: "location",
      type: "string",
      render: (rowData) => {
        return (
          <TableRow onClick={(event) => event.stopPropagation()}>
            <Tooltip title={rowData.ack}>
              <FormGroup style={{ color: themeConfig.neutral.black, paddingBottom: "10px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ padding: "0 10px 20px" }}
                      checked={rowData.ack}
                      disabled={rowData.ack}
                      onChange={() => {
                        handleICERequestAck(rowData);
                      }}
                      name="contact-check"
                    />
                  }
                />
              </FormGroup>
            </Tooltip>
          </TableRow>
        );
      },
    },
  ];

  const updateMoodAck = (request) => {
    let requests = moodRequests.map((e) => {
      if (e.idMoodMeterRequest === request.idMoodMeterRequest) {
        e.ack = true;
      }
      return e;
    });
    setMoodRequests(requests);
  };

  const updateICEAck = (request) => {
    let requests = listOfRequests.map((e) => {
      if (e.iceRequestId === request.iceRequestId) {
        e.ack = true;
      }
      return e;
    });
    setListOfRequests(requests);
  };

  const handleICERequestAck = (request) => {
    ackICERequest({
      variables: {
        idIceRequest: request.iceRequestId,
      },
    })
      .then((response) => {
        if (response?.data?.updateIceAlertRequest) {
          updateICEAck(request);
          NotificationManager.success(
            "Request acknowledged successfully",
            "",
            5000
          );
        } else {
          NotificationManager.error(
            "Something went wrong in acknowledging request",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleAckMoodRequest = (request) => {
    ackMoodMeterRequest({
      variables: {
        idMoodMeterRequest: request.idMoodMeterRequest,
      },
    })
      .then((response) => {
        if (response?.data?.updateMoodMeterRequest) {
          updateMoodAck(request);
          NotificationManager.success(
            "Request acknowledged successfully",
            "",
            5000
          );
        } else {
          NotificationManager.error(
            "Something went wrong in acknowledging request",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleGetProfilePhotoByName = (id, name) => {
    getProfilePhotoByName(id, name).then((data) => {
      console.log("data", data);
      let photo = data[0].url;
      if (photo) {
        setPhotoProfile(photo);
      }
    });
  };

  useEffect(() => {
    if (myProfilePicture && myProfilePicture.avatarType === "TP_AVATAR") {
      handleGetProfilePhotoByName(1, `${myProfilePicture.imageName}`);
    }
    if (myProfilePicture && myProfilePicture.avatarType === "PHOTO") {
      handleGetProfilePhotoByName(1, `${myProfilePicture.imageName}`);
    }
    if (myProfilePicture && myProfilePicture.avatarType === "MONOGRAM") {
      setPhotoProfile("");
      setColorSelected(`${myProfilePicture.jsonConfig}`);
    }
  }, [myProfilePicture]);

  useEffect(() => {
    let startDate = new Date();
    let endDate = new Date();
    startDate.setDate(startDate.getDate() + 1);
    endDate.setDate(endDate.getDate() + 1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    runQueryUpcomingEventsList({
      variables: {
        startSearch: startDate.toUTCString(),
        endSearch: endDate.toUTCString(),
      },
    });
  }, []);

  useEffect(() => {
    if (location.pathname === "/ViewRequests") {
      runQueryIceRequestByWellnessCity().catch((error) =>
        NotificationManager.error(error.message, "", 5000)
      );
      setShowRequestsICE(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    let timeOut;
    if (!openMoodMeterModal && !moodReceived) {
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        handleMoodMeter();
      }, 3600000); //for 1 hour
    } else {
      clearTimeout(timeOut);
    }

    return () => {
      clearTimeout(timeOut);
    };
  }, [moodReceived, openMoodMeterModal]);

  useEffect(() => {
    if (user) {
      runQueryUsersFeelingByUserId({
        variables: {
          userId: user.userId,
        },
      });
    }
  }, [daySaved]);

  useEffect(() => {
    if (isAuthenticated) {
      token(userInfo);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setOverlay(true);
  }, [openMoodMeterModal, openNotifiModal]);

  useEffect(() => {
    if (user) {
      ai.appInsights.setAuthenticatedUserContext(user.email, user.userId, true);
      ai.appInsights.trackPageView({
        isLoggedIn: true,
        properties: {
          upn: user.email,
          oid: user.userId,
        },
      });
      setTpId(user?.email);
    }
  }, [user]);

  useEffect(() => {
    runQueryICEIsThereCityContacts();
  }, [ICEStatus]);

  useEffect(() => {
    runQueryGetICEStatus();
  }, [showLoader, location.pathname]);

  useEffect(() => {
    if (userdata?.currentUser?.location?.cityId) {
      runQueryAllWellnessMailByCity({
        variables: {
          idCity: userdata.currentUser.location.cityId,
        },
      });
    }
  }, [userdata]);

  useEffect(() => {
    runQueryMyProfilePicture({
      context: { clientName: "LinkUsers" },
    });
  }, [openModalProfile]);

  useEffect(() => {
    if (user) {
      runQueryGetMenu({
        context: { clientName: "LinkUsers" },
      });
      runQueryGetUserInfo({
        context: { clientName: "LinkUsers" },
      });
      runQueryUsersFeelingByUserId({
        variables: {
          userId: user.userId,
        },
      });
      /* To display tp id update confirmation popup */
      /*runQueryGetTPIDConfirmation({
        context: { clientName: "LinkUsers" },
      });*/
      handleMoodMeter();
      runQueryGetEventsNotRated();
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(endDate.getDate() + 7); // 7 days from now
      runQueryAllAssignedSurveysAgent({
        variables: {
          fromDate: format_start_date_ISO(startDate),
          toDate: format_end_date_ISO(endDate),
        },
      });
      //runQueryAllAssignedSurveysAgent();
      runQueryIceRequestByWellnessCity().catch((error) =>
        NotificationManager.error(error.message, "", 5000)
      );
      runQueryMoodRequests().catch((error) =>
        NotificationManager.error(error.message, "", 5000)
      );
      runQueryInstantMessages();
      runQueryGetClients({ context: { clientName: "LinkUsers" } });
    }
  }, [user]);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(process.env.API_REST_WELLNESS_REALTIME, {
        accessTokenFactory: () => cookie.getToken("TrustSafety"),
      })
      .withAutomaticReconnect()
      .build();
    setConnectionWR(newConnection);
  }, []);

  useEffect(() => {
    if (connectionWR) {
      connectionWR
        .start()
        .then((result) => {
          connectionWR.on("ReceiveIceBtnClick", (message) => {
            let strMsg = message;
            if (strMsg) {
              setDataICENotification(strMsg);
            }
            if (
              user.roleId === ROLES.SUPER_ADMIN ||
              user.roleId === ROLES.COUNTRY_ADMIN ||
              user.roleId === ROLES.WELLNESS_PROFESSIONAL ||
              user.roleId === ROLES.GAM
            ) {
              setOpenICENotification(strMsg ? true : false);
            }
            runQueryIceRequestByWellnessCity().catch((error) =>
              NotificationManager.error(error.message, "", 5000)
            );
          });
          connectionWR.on("ReceiveNotificationBellBtnClick", (message) => {
            if (message) {
              setNotificationEvent(message);
              setOpenNotifiModal(true);
            }
          });
          connectionWR.on("receiveIceButtonStatus", (data) => {
            setICEStatus(data);
            runQueryIceRequestByWellnessCity().catch((error) =>
              NotificationManager.error(error.message, "", 5000)
            );
          });
          connectionWR.on("ReceiveWellnessResponse", (data) => {
            if (data.length > 0) {
              setICEWellnessMessages([...data]);
              setShowICEAdminMessage(true);
            }
          });
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [connectionWR]);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(process.env.API_REST_SURVEY_REALTIME, {
        accessTokenFactory: () => cookie.getToken("TrustSafety"),
      })
      .withAutomaticReconnect()
      .build();
    setConnectionSR(newConnection);
  }, []);

  useEffect(() => {
    if (connectionSR) {
      connectionSR
        .start()
        .then((result) => {
          connectionSR.on("ReceiveMoodBtnClick", (message) => {
            let strMsg = message;
            if (strMsg) {
              setDataMoodNotification(strMsg);
            }
            if (
              user.roleId === ROLES.SUPER_ADMIN ||
              user.roleId === ROLES.COUNTRY_ADMIN ||
              user.roleId === ROLES.WELLNESS_PROFESSIONAL ||
              user.roleId === ROLES.GAM
            ) {
              setOpenMoodNotification(strMsg ? true : false);
            }
          });
          connectionSR.on("receiveMoodButtonStatus", (data) => {
            setMoodStatus(data);
          });
          connectionSR.on("ReceiveSurveyResponse", (data) => {
            if (data.length > 0) {
              setMoodWellnessMessages([...data]);
              setShowMoodAdminMessage(true);
            }
          });
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [connectionSR]);

  /*   useEffect(() => {
      if (Array.isArray(tenantsList) && tenantsList.length > 0) {
        let tenantSelected = localStorage.getItem("tenantSelected");
        if (tenantSelected) {
          tenantSelected = JSON.parse(tenantSelected);
          setNameClient(tenantSelected.label);
          getLogoForClient(tenantSelected.logo);
        }
      }
    }, [tenantsList, runQueryGetClients]); */

  const getLogoForClient = (imageName) => {
    getFile(imageName)
      .then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setLogoClient(URL.createObjectURL(response));
        } else {
          setLogoClient("");
        }
      })
      .catch((error) => {
        setLogoClient("");

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const getTokenApp = async (data) => {
    const opts = {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + data.accessToken,
      }),
    };
    const response = await fetch(process.env.LOGIN_URL, opts).then((res) => {
      if (res.status === 200) return res.text();
    });
    return response;
  };

  const token = async (data) => {
    setShowLoader(true);
    const response = await getTokenApp(data);
    setShowLoader(false);
    const resObj = JSON.parse(response);
    if (resObj && resObj?.accessToken) {
      cookie.set("TrustSafety", resObj);
      setUser(getStateLoginComplete());
    } else {
      NotificationManager.warning("User does not exist", "", 5000);
    }
  };

  const handleDrawer = (collapse) => {
    setIsCollapse(!collapse);
    setOpen(isCollapse);
  };

  const openMoodmeterDialog = (showPopup, isAdmin) => {
    setOpenMoodMeterModal(showPopup);
    setOpenConfigAdmin(isAdmin);
    if (showPopup) {
      if (refMoodMeterButton.current) {
        setOverlay(false);
      } else {
        setOverlay(true);
      }
    } else if (!refMoodMeterButton.current) {
      runQueryGetEventsNotRated();
    }
  };

  const validateOpenMoodMeterModal = (allFeelingsToday, counter) => {
    if (counter >= 0) {
      if (counter === 0) {
        openMoodmeterDialog(true, true);
      } else if (counter < timeConfig?.recordsPerDay) {
        let lastDate = new Date(
          allFeelingsToday[allFeelingsToday.length - 1]?.createDate
        );
        let intervalDate = new Date(
          lastDate.setHours(lastDate.getHours() + timeConfig?.intervalDuration)
        );
        let newDate = moment(new Date()).utc().format();
        let futureDate = moment(intervalDate).utc().format();
        if (newDate > futureDate) {
          openMoodmeterDialog(true, true);
        } else {
          if (
            (user.roleId === ROLES.GAM ||
              user.roleId === ROLES.SUPER_ADMIN ||
              user.roleId === ROLES.WELLNESS_PROFESSIONAL ||
              user.roleId === ROLES.COUNTRY_ADMIN) &&
            refMoodMeterButton.current
          ) {
            openMoodmeterDialog(true, false);
          } else {
            openMoodmeterDialog(false, false);
          }
          if (refMoodMeterButton.current) {
            setMessageConfigAdmin(
              `This feature is disabled for ${timeConfig?.intervalDuration} hours after using it...`
            );
            NotificationManager.warning(
              `This feature is disabled for ${timeConfig?.intervalDuration} hours after using it`,
              "",
              5000
            );
          }
        }
      } else {
        if (
          (user.roleId === ROLES.GAM ||
            user.roleId === ROLES.SUPER_ADMIN ||
            user.roleId === ROLES.WELLNESS_PROFESSIONAL ||
            user.roleId === ROLES.COUNTRY_ADMIN) &&
          refMoodMeterButton.current
        ) {
          openMoodmeterDialog(true, false);
        } else {
          openMoodmeterDialog(false, false);
        }
        if (refMoodMeterButton.current) {
          setMessageConfigAdmin("You already complete the records of mood...");
          NotificationManager.warning(
            "You already complete the records of mood",
            "",
            5000
          );
        }
      }
    } else if (refMoodMeterButton.current) {
      NotificationManager.warning(
        "You already have problems with the server of mood meter",
        "",
        5000
      );
    }
  };

  const handleUpdate = () => {
    setShowIDModal(false);
    updateTpId({
      variables: {
        newTpid: tpid,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((res) => {
        if (!res?.data?.updateTpId?.withError) {
          NotificationManager.success("Tp Id updated successfully");
        } else {
          setTpId(user?.email);
          NotificationManager.warning("Tp Id already exists");
        }
      })
      .catch((error) => {
        setTpId(user?.email);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleGetDataQr = () => {
    setOpenProfile(null);
    setShowLoader(true);
    GetQrUser({
      context: { clientName: "LinkUsers" },
    }).then((value) => {
      setShowLoader(false);
      if (value.data.showQRUser.message.useTotp) {
        if (value.data.showQRUser.message.qrExists) {
          if (value.data.showQRUser.message.qrCode !== "") {
            setcodeQR(value.data.showQRUser.message.qrCode);
            setShowManualTwoFactor(true);
          } else {
            NotificationManager.warning("Unable to show QR code", "", 5000);
          }
        } else {
          NotificationManager.warning("Unable to show QR code", "", 5000);
        }
      } else {
        NotificationManager.warning("Unable to show QR code", "", 5000);
      }
    });
  };

  let handleMoodMeter = () => {
    runQueryGetTimeConfig();
  };

  const handleSaveFeedback = (id, comments, rating) => {
    if (id) {
      createEventFeedback({
        variables: {
          rating,
          observations: comments,
          idEvent: id,
        },
      })
        .then((res) => {
          if (res?.data?.createEventFeedBack) {
            NotificationManager.success(
              "Thank you for your feedback",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
    let eventsArr = [...eventsNotRated].filter((f) => f.idEvent !== id);
    setEventsNotRated([...eventsArr]);
  };

  const handleLogout = () => {
    handleLogOut();
    setUser("");
    setOpenProfile(null);
  };

  const handleAttendICENotification = (closeModal) => {
    setOpenICENotification(closeModal);
    setShowRequestsICE(true);
  };

  const handleAttendMoodNotification = (closeModal) => {
    setOpenMoodNotification(closeModal);
    runQueryMoodRequests().catch((error) =>
      NotificationManager.error(error.message, "", 5000)
    );
    setShowRequestsMood(true);
  };

  const moveToTenant = () => {
    setShowTenantChange(false);
    setShowLoader(true);

    if (
      typeof rChangeTenant?.current?.state?.ariaSelection?.value === "object"
    ) {
      localStorage.setItem(
        "tenantSelected",
        JSON.stringify(rChangeTenant.current.state.ariaSelection.value)
      );
    }
    let tenantSelected = JSON.parse(localStorage.getItem("tenantSelected"));

    if (
      tenantSelected.clientId &&
      tenantSelected.label &&
      tenantSelected.logo
    ) {
      MoveToClient({
        variables: {
          clientId: tenantSelected.clientId,
          refreshToken: cookie.getRefreshToken("TrustSafety"),
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          if (response?.data?.userMoveToClient?.accessToken) {
            cookie.set("TrustSafety", response.data.userMoveToClient);
            setUser(getStateLoginComplete());
            setNameClient(tenantSelected.label);
            setLogoClient(tenantSelected.logo);
            setShowLoader(false);
          } else {
            handleLogOut();
          }
        })
        .catch((error) => {
          setShowLoader(false);
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  const handleViewRequests = (closeModal, flow) => {
    setShowICE(closeModal);
    if (flow === "sos") {
      runQueryIceRequestByWellnessCity().catch((error) =>
        NotificationManager.error(error.message, "", 5000)
      );
      setShowRequestsICE(true);
    } else {
      runQueryMoodRequests().catch((error) =>
        NotificationManager.error(error.message, "", 5000)
      );
      setShowRequestsMood(true);
    }
  };

  const handleRowMood = (rowSelected) => {
    if (rowSelected?.ack) {
      setSelectedRow(rowSelected?.tableData.id);
      setIceRequestId(rowSelected.idMoodMeterRequest);
      setBackTitleInstant(rowSelected.name);
      setLocationTitleInstant(rowSelected.tpId);
      setShowRequestsMood(false);
      setShowInstantMessagesMood(true);
    } else {
      NotificationManager.warning("Please acknowledge the request");
    }
  };

  let handleRow = (rowSelected) => {
    if (rowSelected?.ack) {
      setSelectedRow(rowSelected.tableData.id);
      setIceRequestId(rowSelected.iceRequestId);
      setBackTitleInstant(rowSelected.name);
      setLocationTitleInstant(rowSelected.tpId);
      setShowRequestsICE(false);
      setShowInstantMessagesICE(true);
    } else {
      NotificationManager.warning("Please acknowledge the request");
    }
  };

  const handleChatbot = () => {
    history.push({
      pathname: "/Chatbot",
    });
  };

  let goToRequestsICE = () => {
    setShowRequestsICE(true);
    setShowInstantMessagesICE(false);
  };

  const goToRequestsMood = () => {
    setShowRequestsMood(true);
    setShowInstantMessagesMood(false);
  };

  let handleSelectInstantMessage = (item, select) => {
    let index = instantMessageSelected.indexOf(item);
    if (select) {
      if (index === -1) {
        setInstantMessageSelected([...instantMessageSelected, item]);
      }
    } else {
      if (index !== -1) {
        setInstantMessageSelected(
          instantMessageSelected.filter((v) => v !== item)
        );
      }
    }
  };

  const handleSendInstantMessageMood = (selected, id) => {
    setShowLoader(true);
    let instanceMessageIds = selected
      .filter((item) => item.instanceMessageId)
      .map((item) => item.instanceMessageId);
    sendMoodInstantMessage({
      variables: {
        idMoodRequest: id,
        instanceMessageIds: instanceMessageIds,
      },
    })
      .then((res) => {
        if (!res.data.sendMoodRequestResponse.withError) {
          NotificationManager.success("The instant messages is sent", "", 5000);
        } else if (res.data.sendMoodRequestResponse.message) {
          NotificationManager.error(
            "Please ack the request and try again",
            "",
            5000
          );
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleSendInstantMessage = (selected, id) => {
    setShowLoader(true);
    let instanceMessageIds = selected
      .filter((item) => item.instanceMessageId)
      .map((item) => item.instanceMessageId);
    sendIceAlertResponse({
      variables: {
        idIceRequest: id,
        instanceMessageIds: instanceMessageIds,
      },
    })
      .then((res) => {
        if (res.data.sendIceAlert) {
          NotificationManager.success("The instant messages is sent", "", 5000);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleOpenModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleSendIceAlert = () => {
    setShowLoader(true);
    sendIceAlert()
      .then((res) => {
        if (res.data.sendIceAlert) {
          NotificationManager.success("The notification is sent", "", 5000);
          handleOpenModal();
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const generateLinkSurvey = (
    encriptParameters,
    preview,
    idSurveyScheduling
  ) => {
    localStorage.setItem("openSurveyDate", new Date());
    if (idSurveyScheduling) {
      localStorage.setItem("idSurveyScheduling", idSurveyScheduling);
    } else {
      localStorage.setItem("idSurveyScheduling", "");
    }
    history.push(
      `/FillOutSurvey?ParamToken=${encriptParameters}&Preview=${preview}`
    );
  };

  const handleEncriptParametersSurvey = (
    idSurvey,
    preview,
    idSurveyScheduling
  ) => {
    encriptParameters({
      variables: {
        idSurvey: idSurvey.toString(),
      },
    })
      .then((value) => {
        const { encriptParameters } = value.data;
        generateLinkSurvey(encriptParameters, preview, idSurveyScheduling);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const isUserAuthorized =
    user.roleId === ROLES.SUPER_ADMIN ||
    user.roleId === ROLES.COUNTRY_ADMIN ||
    user.roleId === ROLES.GAM ||
    user.roleId === ROLES.WELLNESS_PROFESSIONAL;

  let handleCloseInteraction = (id) => {
    setShowLoader(true);
    closeIceAlertRequest({
      variables: {
        idIceRequest: id,
      },
    })
      .then((res) => {
        if (res.data.closeIceAlertRequest) {
          NotificationManager.success(
            "The Quick Assist interaction is closed",
            "",
            5000
          );
          setShowInstantMessagesICE(false);
          setInstantMessageSelected([]);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleCloseMoodInteraction = (id) => {
    setShowLoader(true);
    closeMoodAlertRequest({
      variables: {
        idMoodMeterRequest: id,
      },
    })
      .then((res) => {
        if (res.data.closeMoodMeterRequest) {
          NotificationManager.success(
            "The Request is closed successfully.",
            "",
            5000
          );
          setShowInstantMessagesMood(false);
          setShowRequestsMood(false);
          setInstantMessageSelected([]);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleOpenModalProfile = (showPopup) => {
    setOpenModalProfile(showPopup);
  };

  const openApps = () => {
    return (
      <HtmlTooltip
        arrow
        placement="bottom"
        open={openAppsHandler}
        title={
          <ClickAwayListener onClickAway={() => setOpenAppsHandler(false)}>
            <ContentTooltip>
              <a target="_blank" href={urlKnowledged} rel="noreferrer">
                <ImageContainer>
                  <ButtonApp src={knowledgeWafle}></ButtonApp>

                  <span>Knowledge Management</span>
                </ImageContainer>
              </a>
            </ContentTooltip>
          </ClickAwayListener>
        }
      >
        <AppsIcon
          style={{ color: themeConfig.text.primary }}
          fontSize="medium"
          onClick={() => setOpenAppsHandler(openAppsHandler ? false : true)}
        />
      </HtmlTooltip>
    );
  };

  return (
    <GeneralStyle choice={choiceSelected} isCollapse={isCollapse} user={user}>
      <CssBaseline />
      {(showLoader ||
        loadingGetMenu ||
        loadingEvents ||
        loadingMoodRequests ||
        loadingICERequests) && (
          <ModalLoader loaderHomeScreen={true}></ModalLoader>
        )}
      <AppBar
        position="fixed"
        className={`ContentHeader ${clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}`}
      >
        <div className="menu-button">
          <IconCollapseStyle>
            <IconButton
              onClick={() => {
                handleDrawer(isCollapse);
              }}
            >
              {" "}
              {isCollapse && <MenuIconCollapse />}
              {!isCollapse && <MenuIconExpand />}
            </IconButton>
          </IconCollapseStyle>
        </div>

        {user && (
          <SideMenu
            menuClass="tab-mobile-menu"
            menuList={menuList}
            setIsCollapse={setIsCollapse}
            user={user}
            isCollapse={isCollapse}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            handleDrawer={handleDrawer}
            choiceSelected={choiceSelected}
            setChoiceSelected={setChoiceSelected}
            setShowICE={setShowICE}
            activeIceButton={activeIceButton}
            ICEStatus={ICEStatus}
          />
        )}
        <Toolbar className="ContentToolbar">
          <ImgLogoTPHomeMenu srclogo={logohomemenu}></ImgLogoTPHomeMenu>
        </Toolbar>
        {user && (
          <NameClient super={nameClient?.length ? true : false}>
            {tenantsList.length === 0 && <div></div>}
            {tenantsList.length > 0 && (
              <Tooltip arrow title="Change Tenant">
                <div
                  onClick={() => {
                    if (tenantsList.length > 1) {
                      setShowTenantChange(true);
                    }
                  }}
                >
                  {logoClient && <img src={logoClient} alt={nameClient} />}
                  {tenantsList.length > 1 && <ArrowDropDownIcon />}
                </div>
              </Tooltip>
            )}
          </NameClient>
        )}
        {user && (
          <DisplayName>
            {user.roleId && (
              <>
                {user.clientId !== 13 && (
                  <div className="relative-container-ice">
                    {ROLES.AGENT !== user.roleId ? (
                      <>
                        <label
                          className="ice-label-clickeable"
                          onClick={() => {
                            if (ICEStatus !== "Open") {
                              setShowICE(true);
                            } else {
                              setShowICEInfo(true);
                            }
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              if (ICEStatus !== "Open") {
                                setShowICE(true);
                              } else {
                                setShowICEInfo(true);
                              }
                            }
                          }}
                          style={{
                            opacity: activeIceButton && ICEStatus === "Closed" ? "1" : "0.4",
                            cursor: activeIceButton && ICEStatus === "Closed" ? "pointer" : "default",
                          }}
                        >
                          Quick Assist
                        </label>
                      </>
                    ) : null}

                    <label
                      className="ICE-label"
                      onClick={() => {
                        setShowICE(true);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          setShowICE(true);
                        }
                      }}
                    >
                      Quick Assist
                    </label>
                    {listOfRequests?.length >= 1 && (
                      <HtmlTooltip
                        arrow
                        placement="bottom"
                        open={openICERequests}
                        title={
                          <ClickAwayListener
                            onClickAway={(e) => setOpenICERequests(false)}
                          >
                            <ContentTooltip>
                              <IconButton
                                onClick={() => {
                                  handleViewRequests(false, "sos");
                                  setOpenICERequests(false);
                                }}
                              >
                                View Requests <Visibility />
                              </IconButton>
                            </ContentTooltip>
                          </ClickAwayListener>
                        }
                      >
                        <SOSCountRequests
                          onClick={() => {
                            setOpenICERequests(true);
                          }}
                        >
                          {listOfRequests?.length}
                        </SOSCountRequests>
                      </HtmlTooltip>
                    )}
                  </div>
                )}
                <div hidden={true}>
                  <button
                    type="button"
                    style={{ background: "transparent", border: "none" }}
                    onClick={() => handleChatbot()}
                  >
                    <ChatIcon style={{ margin: " 0 -4px", marginTop: "3px" }} />
                  </button>
                </div>
                {(loadingFeeling && !errorFeeling) ||
                  (loadingGetTimeConfig && !errorGetTimeConfig) ? (
                  <div
                    style={{ paddingBottom: "1.2rem", paddingLeft: "1.5rem" }}
                  >
                    <PointersLine
                      moodMeter={true}
                      color={themeConfig.text.primary}
                      left={"-2.5em"}
                      width={"2.5em"}
                    ></PointersLine>
                  </div>
                ) : (
                  <div className="mood-meter-btn">
                    <ButtonMoodMeter
                      isDisabled={
                        Array.isArray(selectedUsersForMoodMeter) &&
                        selectedUsersForMoodMeter?.length === 0
                      }
                      disabled={
                        Array.isArray(selectedUsersForMoodMeter) &&
                        selectedUsersForMoodMeter?.length === 0
                      }
                      style={{ position: "relative" }}
                      onClick={() => {
                        refMoodMeterButton.current = true;
                        handleMoodMeter();
                      }}
                    >
                      {isUserAuthorized && moodRequests?.length > 0 && (
                        <div className="notification-icon">
                          <span>{moodRequests?.length}</span>
                        </div>
                      )}
                      <IconMoodMeterMenu
                        style={
                          Array.isArray(selectedUsersForMoodMeter) &&
                            selectedUsersForMoodMeter?.length === 0
                            ? { opacity: "0.4" }
                            : { opacity: "1" }
                        }
                      />
                    </ButtonMoodMeter>
                    <div
                      hidden={
                        Array.isArray(selectedUsersForMoodMeter) &&
                        selectedUsersForMoodMeter?.length === 0
                      }
                      style={{
                        position: "fixed",
                        right: "1.5%",
                        top: "5rem",
                      }}
                    >
                      {openMoodMeterModal && (
                        <>
                          <Overlay showOverlay={overlay}></Overlay>
                          <MoodMeterContainer
                            messageConfigAdmin={messageConfigAdmin}
                            openConfigAdmin={openConfigAdmin}
                            setOpenMoodMeterModal={setOpenMoodMeterModal}
                            setDaySaved={setDaySaved}
                            timeConfig={timeConfig}
                            openMoodMeterModal={openMoodMeterModal}
                            superVisorId={superVisorId}
                            handleViewRequests={handleViewRequests}
                            setMoodReceived={setMoodReceived}
                          ></MoodMeterContainer>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {/* </Tooltip> */}
                <ContainterNotificationHome>
                  <Tooltip
                    title={
                      eventsAssigned.length > 0 ||
                        notificationEvent !== "" ||
                        surveysAssigned.length > 0
                        ? ""
                        : "No new notifications. Check back later for updates."
                    }
                  >
                    <ButtonNotification
                      disabled={
                        eventsAssigned.length > 0 ||
                          notificationEvent !== "" ||
                          surveysAssigned.length > 0
                          ? false
                          : true
                      }
                      isDisabled={
                        eventsAssigned.length > 0 ||
                          notificationEvent !== "" ||
                          surveysAssigned.length > 0
                          ? false
                          : true
                      }
                      onClick={() => setOpenNotifiModal(true)}
                    >
                      <MenuIconNotification />
                    </ButtonNotification>
                  </Tooltip>

                  {!openMoodMeterModal &&
                    openNotifiModal &&
                    (eventsAssigned.length > 0 ||
                      notificationEvent !== "" ||
                      surveysAssigned.length > 0) && (
                      <>
                        <span
                          className="arrow-up"
                          style={{
                            position: "absolute",
                            top: "33px",
                            right: "34.5%",
                            zIndex: "4",
                          }}
                        ></span>
                        <Overlay showOverlay={overlay}></Overlay>
                        <AllEventPrompts
                          notificationEvent={notificationEvent}
                          eventsAssigned={eventsAssigned}
                          setEventsAssigned={setEventsAssigned}
                          setOpenNotifiModal={setOpenNotifiModal}
                          surveysAssigned={surveysAssigned}
                          handleEncriptParametersSurvey={
                            handleEncriptParametersSurvey
                          }
                        />
                      </>
                    )}
                </ContainterNotificationHome>
              </>
            )}
            <RightSeparator
              loadingFeeling={loadingFeeling}
              errorFeeling={errorFeeling}
              loadingGetTimeConfig={loadingGetTimeConfig}
              errorGetTimeConfig={errorGetTimeConfig}
            />
            <ContentUserInfo>
              <HtmlTooltipProfile
                arrow
                placement="bottom"
                open={openProfile ? openProfile : false}
                title={
                  <ClickAwayListener onClickAway={(e) => setOpenProfile(null)}>
                    <div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 2fr",
                        }}
                      >
                        <Col
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          className="user-icon"
                          onClick={() => handleOpenModalProfile(true)}
                        >
                          <Picture
                            photo={`${photoProfile}`}
                            bgColor={`${colorSelected}`}
                            valuePictureWidth={25}
                          >
                            {!photoProfile &&
                              (colorSelected ? (
                                shortName
                              ) : (
                                <ContentPersonIcon>
                                  <PersonOutlineIcon
                                    className="person-icon"
                                    fontSize="medium"
                                  />
                                </ContentPersonIcon>
                              ))}
                          </Picture>
                        </Col>
                        <Col className="px-0 my-1 username-role">
                          <p
                            className="my-3 user-name"
                            style={{ fontSize: "16px", color: "white" }}
                          >
                            {openProfile?.displayName}
                          </p>
                          <p
                            className="my-2 user-role"
                            style={{ fontSize: "12px", color: themeConfig.neutral.black }}
                          >
                            <b>{openProfile?.roleDescription}</b>
                          </p>
                        </Col>
                      </div>
                      <TPIDContainer>
                        <label>{tpid}</label>
                        {/* <IconButton onClick={() => setShowIDModal(true)}>
                          <Edit />
                        </IconButton> */}
                      </TPIDContainer>
                      <HR />
                      <div
                        style={{
                          marginTop: "55px",
                        }}
                      >
                        <Col
                          md={12}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            marginTop: "-2vw",
                          }}
                        >
                          <ImageLogout onClick={handleLogout}>
                            <Tooltip title="Sign off" placement="bottom">
                              <div
                                className="mb-1"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  className="mr-1 sign-out"
                                  style={{
                                    color: themeConfig.neutral.black,
                                    fontSize: "15px",
                                  }}
                                >
                                  Sign Out
                                </span>
                                <LogOutIcon
                                  style={{
                                    color: themeConfig.text.primary,
                                    fontSize: "default",
                                    marginLeft: "8px",
                                    marginRight: "1.5em",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </ImageLogout>
                        </Col>
                      </div>
                    </div>
                  </ClickAwayListener>
                }
              >
                <ContentProfileIcon onClick={() => setOpenProfile(user)}>
                  <MiniPicture
                    photo={`${photoProfile}`}
                    bgColor={`${colorSelected}`}
                    valuePictureWidth={25}
                  >
                    {!photoProfile &&
                      (colorSelected ? (
                        shortName
                      ) : (
                        <ContentPersonIcon>
                          <PersonIcon className="person-icon"></PersonIcon>
                        </ContentPersonIcon>
                      ))}
                  </MiniPicture>

                  <ArrowDropDownIcon className="arrow-drop-dowm"></ArrowDropDownIcon>
                </ContentProfileIcon>
              </HtmlTooltipProfile>
            </ContentUserInfo>
            {user.clientId == "105603" && <ImageApps>{openApps()}</ImageApps>}
          </DisplayName>
        )}
        {!user && <LoginButton onClick={() => { }}>Login</LoginButton>}
      </AppBar>
      <div
        style={{
          display: "grid",
          width: "100%",
          position: "absolute",
        }}
      >
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <MainContent className={user ? classes.homeLoggedinContent : ""}>
            {user && (
              <SideMenu
                menuClass="desktop-menu"
                setIsCollapse={setIsCollapse}
                menuList={menuList}
                user={user}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                isCollapse={isCollapse}
                handleDrawer={handleDrawer}
                choiceSelected={choiceSelected}
                setChoiceSelected={setChoiceSelected}
                setShowICE={setShowICE}
                activeIceButton={activeIceButton}
                ICEStatus={ICEStatus}
              />
            )}
            <ContentRight
              homePage={
                location.pathname === "/" || location.pathname === "/Home"
                  ? true
                  : false
              }
            >
              {children}
            </ContentRight>
          </MainContent>
        </main>
      </div>
      {stateBulkUploadReducer.messageBulkshow && (
        <PortalModal>
          <ContentModalGlobal>
            <CloseModalGlobal>
              <span onClick={() => dispatch({ type: "loaded" })}>X</span>
            </CloseModalGlobal>
            <TextModalGlobal>
              <ErrorOutlinedIcon />
              {stateBulkUploadReducer.messageBulk.success ? (
                <p>{stateBulkUploadReducer.messageBulk.message}</p>
              ) : (
                <p>
                  {stateBulkUploadReducer.messageBulk.message}
                  <br />
                  go to the users history to view detailed file
                </p>
              )}
            </TextModalGlobal>
            <div
              style={{ display: "inline-flex", margin: "auto", width: "100%" }}
            >
              <ButtonGlobal onClick={() => dispatch({ type: "loaded" })}>
                Ok
              </ButtonGlobal>
            </div>
          </ContentModalGlobal>
        </PortalModal>
      )}
      {showManualTwoFactor && (
        <PortalModal>
          <ContentQr>
            <HeaderContentQr>
              <div>Two-factor authentication</div>
              <CloseIcon onClick={() => setShowManualTwoFactor(false)} />
            </HeaderContentQr>
            <InfoQrCode>
              <QrImg
                className={"my-2"}
                src={"data:image/png;base64," + codeQR}
                alt=""
              />
            </InfoQrCode>
          </ContentQr>
        </PortalModal>
      )}
      {eventsNotRated.length > 0 && !openMoodMeterModal && (
        <>
          <EventsFeedbackContainer
            events={eventsNotRated}
            handleSaveFeedback={handleSaveFeedback}
          />
        </>
      )}
      <div
        style={{
          position: "fixed",
          right: "1.5%",
          top: "5rem",
          zIndex: 2000,
        }}
      >
        {openModalProfile && (
          <>
            <Overlay showOverlay={openModalProfile}></Overlay>
            <ModalProfile
              user={user}
              setOpenModalProfile={setOpenModalProfile}
            />
          </>
        )}
      </div>
      {openICENotification && (
        <NotificationResearchContainer
          data={dataICENotification}
          setOpen={setOpenICENotification}
          fn={handleAttendICENotification}
        ></NotificationResearchContainer>
      )}
      {openMoodNotification && (
        <NotificationResearchContainer
          data={dataMoodNotification}
          setOpen={setOpenMoodNotification}
          fn={handleAttendMoodNotification}
        ></NotificationResearchContainer>
      )}
      {showICE && (
        <ModalConfirm
          info={`This request is for IMMEDIATE help from your wellness team. Are you sure to send it?`}
          handleConfirm={handleSendIceAlert}
          setModalVisibility={setShowICE}
          showCancel={true}
          modalTitle="Quick Assist"
        />
      )}
      {isModalOpen && <IceButtonComponent setIsModalOpen={!isModalOpen} />}

      {showICEInfo && (
        <ModalConfirm
          info={`You will be contacted soon.`}
          handleConfirm={handleSendIceAlert}
          setModalVisibility={setShowICEInfo}
          showCancel={false}
          modalTitle="Quick Assist"
        />
      )}
      {/*       {(user.roleId === ROLES.SUPER_ADMIN ||
        user.roleId === ROLES.COUNTRY_ADMIN ||
        user.roleId === ROLES.GAM ||
        user.roleId === ROLES.SUPERVISOR) &&
        showICE && (
          <ModalSOS
            setShowModal={setShowICE}
            fn={handleViewRequests}
            handleSendIceAlert={handleSendIceAlert}
            ICEStatus={ICEStatus}
            showViewRequestBtn={true}
          />
        )} */}
      {showRequestsICE && (
        <ModalRequestsSOS
          setShowRequestsSOS={setShowRequestsICE}
          handleRow={handleRow}
          selectedRow={selectedRow}
          listOfRequests={listOfRequests}
          title="Quick Assist Requests"
          columnData={ICERequestColumns}
        />
      )}
      {showRequestsMood && (
        <ModalRequestsSOS
          setShowRequestsSOS={setShowRequestsMood}
          handleRow={handleRowMood}
          selectedRow={selectedRow}
          listOfRequests={moodRequests}
          title="Mood Meter Requests"
          columnData={MoodRequestColumns}
        />
      )}
      {showInstantMessagesICE && (
        <ModalInstantMessages
          setShowInstantMessagesSOS={setShowInstantMessagesICE}
          selectedRow={selectedRow}
          iceRequestId={iceRequestId}
          backTitle={backTitleInstant}
          locationTitle={locationTitleInstant}
          goToBackPage={goToRequestsICE}
          listOfInstantMessage={listOfInstantMessage}
          handleSendInstantMessage={handleSendInstantMessage}
          handleSelectInstantMessage={handleSelectInstantMessage}
          instantMessageSelected={instantMessageSelected}
          setInstantMessageSelected={setInstantMessageSelected}
          handleCloseInteraction={handleCloseInteraction}
        />
      )}
      {showInstantMessagesMood && (
        <ModalInstantMessages
          setShowInstantMessagesSOS={setShowInstantMessagesMood}
          selectedRow={selectedRow}
          iceRequestId={iceRequestId}
          backTitle={backTitleInstant}
          locationTitle={locationTitleInstant}
          goToBackPage={goToRequestsMood}
          listOfInstantMessage={listOfInstantMessage}
          handleSendInstantMessage={handleSendInstantMessageMood}
          handleSelectInstantMessage={handleSelectInstantMessage}
          instantMessageSelected={instantMessageSelected}
          setInstantMessageSelected={setInstantMessageSelected}
          handleCloseInteraction={handleCloseMoodInteraction}
        />
      )}
      {showICEAdminMessage && ICEWellnessMessages.length > 0 && (
        <ModalICEAdminMessage
          messages={ICEWellnessMessages}
          setModalVisibility={setShowICEAdminMessage}
        />
      )}
      {showMoodAdminMessage && MoodWellnessMessages.length > 0 && (
        <ModalICEAdminMessage
          messages={MoodWellnessMessages}
          setModalVisibility={setShowMoodAdminMessage}
        />
      )}
      {showIDModal && (
        <PortalModal>
          <CenterContainer>
            <ModalUpdateId
              tpid={tpid}
              setTpId={setTpId}
              handleUpdate={handleUpdate}
            />
          </CenterContainer>
        </PortalModal>
      )}
      {showTenantChange && (
        <PortalModal>
          <ContentChangeTenant>
            <div>
              <CloseIcon
                style={{ float: "right", cursor: "pointer" }}
                onClick={() => setShowTenantChange(false)}
              />
            </div>
            <div style={{ padding: "1em" }}>
              {/* <label >Client: </label> */}
              <div>
                <Form.Label style={{ color: themeConfig.primary.icon }}>
                  Change Tenant:
                </Form.Label>{" "}
                <Select
                  styles={customStyles}
                  placeholder="Select a client"
                  ref={rChangeTenant}
                  defaultValue={selectedTenantOption}
                  options={tenantsList.filter((f) => f.value !== user.clientId)}
                />
              </div>
            </div>
            <ButtonsChangeTenant>
              <ButtonCancel
                onClick={() => {
                  setShowTenantChange(false);
                }}
              >
                Cancel
              </ButtonCancel>
              <ButtonCreate
                onClick={() => {
                  moveToTenant();
                }}
              >
                Accept
              </ButtonCreate>
            </ButtonsChangeTenant>
          </ContentChangeTenant>
        </PortalModal>
      )}
    </GeneralStyle>
  );
};

export default HomeMain;

HomeMain.propTypes = {
  isAuthenticated: PropTypes.bool,
  userInfo: PropTypes.object,
  handleLogin: PropTypes.func,
  handleLogOut: PropTypes.func,
  menuList: PropTypes.array,
  setMenuList: PropTypes.func,
  children: PropTypes.any,
};
